import React, {Component, useContext, useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import { Button, ButtonCancel, ButtonModify, ButtonProceed, ButtonReturn } from '../../../../components/buttons';
import { Layout, MinMaxLayout, SeventyThirtyLayout, SixtyFourtyLayout } from '../../../../layouts';
import Welcome from '../../../../layouts/welcome';
import Row from '../../../../components/row';
import Container from '../../../../layouts/containers/container';
import List from '../../../../components/list';
import ContainerTable from '../../../../layouts/containers/container-table';
import InputsCheckbox from '../../../../components/inputs/inputs-checkbox';
import LabelContainer from '../../../../components/label-container';
import Blurred from '../../../../components/blurred';
import InputsCounter from '../../../../components/inputs/inputs-counter';
import DateTimeInput from '../../../../components/inputs/date-time-input';
import ErrorContainer from '../../../../components/error-container';
import InputsText from '../../../../components/inputs/inputs-text';
import _ from 'lodash';
import PopupsAdditionalPackageDetails from '../../../bookings/popups/popups-additional-package-details';
import PopupContext from '../../../../context/context-popup';
import PopupsAttendees from '../../popups/popups-attendees-manual';
import eventsApi from '../../../../lib/events/events-api';
import queryString from 'query-string';
import PopupsAttendeesMixed from '../../popups/popups-attendees-mixed';
import PopupsAttendeesManual from '../../popups/popups-attendees-manual';
import BillingDetails from '../../../../components/billing-profile';

const YourDetails = ({ booker }) => {
    const Item = ({ title, value }) => {
        return (
            <List gap='10px' style={{ flex: '1 0 0' }}>
                <LabelContainer label={title}>
                    { value }
                </LabelContainer>
            </List>
        )
    }

    const Flex = ({ direction, children }) => {
        return (
            <div style={{
                display: 'flex',
                flexDirection: direction,
                gap: '20px',
            }}>
                { children }
            </div>
        )
    }

    const profile = booker?.billing_profile;

    return (
        <Container>
            <Container.Header>
                <Container.Text color="#FF6933" fontSize="18px">Your Details</Container.Text>
            </Container.Header>

            <Container.Content>
                <Flex direction="column">
                    <Flex direction="row">
                        <Item title="First Name" value={profile?.first_name}/>
                        <Item title="Last Name" value={profile?.last_name}/>
                    </Flex>
                    <Flex direction="row">
                        <Item title="Company" value={profile?.company_name}/>
                    </Flex>
                    <Item title="Email Address" value={profile?.email_address}/>
                    <Flex direction="row">
                        <Item title="Telephone Number" value={profile?.tel_no}/>
                        <Item title="SAP Number" value={profile?.sap_number || 'Not Set'}/>
                    </Flex>
                </Flex>
            </Container.Content>
        </Container>
    )
}

const Summary = ({
    quote,
}) => {
    const data = []

    if (quote !== null) {
        quote?.tickets?.forEach(ticket => {
            data.push([
                ticket?.quantity,
                ticket?.name,
                `£${ticket?.total}`
            ])
        })
    }

    return (
        <ContainerTable
            className="table-bookings"
            columns={[
                { field: 'QTY', width: '25%' },
                { field: 'Item', width: '50%' },
                { field: 'Price', width: '25%' },
            ]}
            data={[
                ...data
            ]}
        />
    )
}

const Ticket = ({
    index,
    error,
    ticket,
    onTicketQuantityChange
}) => {
    return (
        <ErrorContainer errors={error}>
            <Row gap="20px" justifyContent="space-between">
                <LabelContainer label={<Container.Text fontSize="16px" color="black">{ ticket?.name }</Container.Text>}>
                    <Container.Text fontSize="14px">£{ticket?.price || 0}</Container.Text>
                </LabelContainer>

                <List gap="10px">
                    <InputsCounter
                        value={ticket?.quantity}
                        onChange={e => onTicketQuantityChange(ticket?.id, e)}
                        max={ticket?.quantity_available}
                    />
                    {/* <Container.Text fontSize="16px" color="#1976F8">{ticket?.quantity_available} available</Container.Text> */}
                </List>
            </Row>
        </ErrorContainer>
    )
}

const Tickets = ({
    tickets,
    onTicketQuantityChange,
    getTicketError,
    attendees,
    onAttendeeAdd,
    onAttendeeDelete,
    onAttendeeUpdate,
    event,
    booking,
    howManyTicketsLeftMapped
}) => {
    const { setPopup } = useContext(PopupContext);

    const showAttendees = () => {
        setPopup(<PopupsAttendeesManual
            attendees={attendees} 
            onAttendeeAdd={onAttendeeAdd} 
            onAttendeeDelete={onAttendeeDelete} 
            onAttendeeUpdate={onAttendeeUpdate}
            howManyTicketsLeftMapped={howManyTicketsLeftMapped}
        />);
    }

    return <List gap="20px">
        { tickets?.map((ticket, index) => <Ticket error={getTicketError(index)} key={index} index={index} ticket={ticket} onTicketQuantityChange={onTicketQuantityChange}/>) }

        <ButtonModify onClick={showAttendees}>Attendee Information</ButtonModify>
    </List>
}

class EventEdit extends Component {
    constructor(props) {
        super(props);

        this.state = {
           params: {
            tickets: [],
            discount: 0,
            booker_type: 'App\\Models\\User',
            booker_id: window.user.id,
            payment_type: 'bacs',
           },
           errors: {},
           agree: false,
           quote: null,
           event: null,
        }
    }

    componentDidMount() {
        this.getEvent();
    }

    getEvent() {
        eventsApi.getEvent(this.props.id).then(({ data }) => {
            this.setState({ event: data }, () => {
                this.getBooking();
            });
        })
    }

    getBooking() {
        eventsApi.getEventBooking(this.props.id, this.props.bookingId).then(({ data }) => {
            this.setState({ 
                params: {
                    ...data,
                    attendees: data?.event_attendees,
                }
            }, () => {
                this.setupTickets();
            });
        })
    }

    book() {
        let params = { ...this.state.params };

        params.tickets = params.tickets.filter(ticket => ticket.quantity > 0);

        eventsApi.updateBooking(this.props.id, this.props.bookingId, params, (errors) => {
            this.checkErrors(errors);
        }).then(({ data }) => {
            window.location.href = `/mydmc/events/${this.props.id}/bookings/${data.id}`;
        })
    }

    checkErrors(errors) {
        let error = '';

        this.setState({ errors }, () => {
            const errorsList = this.state.errors;

            if (errorsList.hasOwnProperty('attendees')) {

            }
        });
    }

    onChangeNameValue(name, value) {
        const params = { ...this.state.params }

        params[name] = value;
xx
        this.setState({ params });
    }

    onChangeObject(obj, callback = () => {}) {
        const params = { 
            ...this.state.params,
            ...obj 
        }

        this.setState({ params }, callback)
    }

    getTicketBooking(ticketId) {
        const tickets = this.state.params?.event_ticket_type_bookings;

        return tickets?.find(ticket => ticket.event_ticket_type_id === ticketId);
    }

    setupTickets() {
        let tickets = [ ...this.state.event.event_ticket_types ];

        tickets = tickets?.map((ticket) => {
            const queryParamsQuantity = this.getTicketBooking(ticket.id)?.quantity;

            return {
                ...ticket,
                event_ticket_type_id: ticket?.id,
                quantity: Number.parseInt(queryParamsQuantity) || 0,
            }
        });

        this.onChangeObject({ tickets }, () => {
            this.getBookingCosts();
        });
    }

    onTicketQuantityChange(id, value) {
        const tickets =  [ ...this.state.params?.tickets ];
        const index = tickets.findIndex(e => e.event_ticket_type_id === id);

        tickets[index].quantity = value;

        this.onChangeObject({ tickets }, () => this.getBookingCosts());
    }

    getBookingCosts = _.debounce(() => {
        eventsApi.getBookingCosts(this.state.event.id, {
            tickets: this.state.params.tickets?.map(({ event_ticket_type_id, quantity }) => {
                return {
                    event_ticket_type_id,
                    quantity
                }
            }).filter(({ quantity }) => quantity > 0),
            discount: this.state.params?.discount,
        }).then(({ data }) => {
            let newData = { ...data };

            newData.tickets = newData.tickets.map((ticket) => {
                const eventTicket = this.state.params.tickets.find(({ event_ticket_type_id }) => event_ticket_type_id === ticket.event_ticket_type_id);

                return {
                    ...ticket,
                    ...eventTicket
                }
            })

            this.setState({ quote: newData }, () => {
                this.addCostsToTickets();
            })
        })
    }, 500, null);
    
    getQuoteTicket(id) {
        const ticket = this.state.quote?.tickets?.find(t => t.event_ticket_type_id === id);

        return {
            total: ticket?.total,
            errors: ticket?.errors,
        }
    }

    getTicketError(index) {
        const errors = Object.keys(this.state.errors)?.
            filter(key => key.startsWith(`event_ticket_types.${index}`)).
            map(key => {
                return this.state.errors[key]
            });

        return errors;
    }

    addCostsToTickets() {
        let tickets = [ ...this.state.params.tickets ];

        tickets = tickets.map((ticket) => {
            return {
                ...ticket,
                price: this.getQuoteTicket(ticket?.id)?.total
            }
        })

        this.onChangeObject({ tickets });
    }

    onAttendeeAdd(attendee) {
        const attendees = this.state.params?.attendees !== undefined ? [ ...this.state.params.attendees ] : [];

        let data = { ...attendee }

        delete data.meeting_attendee_id;
        delete data.meeting_attendee_type;
        delete data.personSelected;

        const type = attendee?.personSelected !== null ? 'App\\Models\\User' : 'App\\Models\\Contact';

        if (attendee.hasOwnProperty('attendee_details')) {
            attendees.push(data);
        } else {
            delete data.attendee_details;

            attendees.push({
                attendee_type: type,
                attendee_id: attendee?.personSelected?.id,
                ...data,
            })
        }

        this.onChangeObject({ attendees });
    }

    onAttendeeDelete(attendeeIndex) {
        let attendees = this.state.params?.attendees !== undefined ? [ ...this.state.params.attendees ] : [];

        attendees = attendees.filter((_, index) => index !== attendeeIndex);

        this.onChangeObject({ attendees });
    }

    onAttendeeUpdate(index, attendee) {
        const attendees = this.state.params?.attendees !== undefined ? [ ...this.state.params.attendees ] : [];

        let foundAttendee = attendees?.[index];

        const ticket = this.state.params?.tickets?.find(t => t.event_ticket_type_id === attendee.event_ticket_type_id);

        if (foundAttendee) {
            attendees[index] = {
                ...attendee,
                event_ticket_type: {
                    name: ticket?.name || 'Not Selected',
                }
            }
        }

        this.onChangeObject({ attendees });
    }

    howManyTicketsLeft() {
        const tickets = this.state.params?.tickets || [];

        const attendeesAssignedTickets = this.state.params?.attendees?.
            filter(attendee => attendee.event_ticket_type_id !== undefined && attendee.event_ticket_type_id !== null) || [];

        const ticketUsageCount = tickets?.reduce((count, ticket) => {
            const selectedTicketId = ticket.id;
            const quantity = ticket.quantity;
        
            count[selectedTicketId] = quantity;
            
            attendeesAssignedTickets.forEach(attendee => {
                if (attendee.event_ticket_type_id === selectedTicketId) {
                    count[selectedTicketId]--;
                }
            });
            
            return count;
        }, {});

        return ticketUsageCount;
    }

    howManyTicketsLeftMapped() {
        const ticketsLeft = this.howManyTicketsLeft();
        const tickets = this.state.params?.tickets;

        return tickets?.map(ticket => {
            return {        
                ...ticket,
                left: ticketsLeft?.[ticket?.id]
            }
        })
    }

    render() {
        const quote = this.state.params?.receipt || this.state.params?.saved_quote;

        return (
            <Layout 
                theme="light"
                loading={this.state.booking === null}
                topLeft={<Welcome title="Event Booking" subtitle={this.state.event?.name}/>}
                topRight={
                    <Row gap="20px">
                        <ButtonReturn onclick={() => window.location.href = `/mydmc/events/${this.props.id}/bookings/${this.props.bookingId}`}>Cancel</ButtonReturn>
                    </Row>
                }
            >
            <MinMaxLayout
                main={
                    <div className="booking-view">
                        <List gap="40px" className="booking-view__child">
                            <Container>
                                <Container.Header>
                                    <Container.Text color="#FF6933" fontSize="18px">Confirm Details</Container.Text>
                                </Container.Header>

                                <Container.Content> 
                                    <List gap="40px">
                                        <div className="booking-view__image" style={{ backgroundImage: `url('')` }}></div>

                                        <LabelContainer label='Event Name'>
                                           { this.state.event?.name }
                                        </LabelContainer>

                                        <LabelContainer label="Booking Date & Duration">
                                            <DateTimeInput
                                                readOnly
                                                value={[
                                                    this.state.event?.start,
                                                    this.state.event?.duration_mins
                                                ]}
                                            />
                                        </LabelContainer>

                                        <LabelContainer label='Your Tickets (max. 8 tickets per booking)'>
                                            <Tickets
                                                howManyTicketsLeftMapped={this.howManyTicketsLeftMapped()}
                                                tickets={this.state.params.tickets}
                                                onTicketQuantityChange={this.onTicketQuantityChange.bind(this)}
                                                getTicketError={this.getTicketError.bind(this)}
                                                attendees={this.state.params?.attendees}
                                                onAttendeeAdd={this.onAttendeeAdd.bind(this)}
                                                onAttendeeDelete={this.onAttendeeDelete.bind(this)}
                                                onAttendeeUpdate={this.onAttendeeUpdate.bind(this)}
                                                refresh={this.getBooking.bind(this)}
                                                event={this.state.event}
                                                booking={this.state.booking}
                                            />
                                        </LabelContainer>

                                        <LabelContainer label='Booking Location'>
                                            Location
                                        </LabelContainer>
                                    </List>
                                </Container.Content>
                            </Container>

                            <BillingDetails
                                viewOnly
                                booker={quote}
                            />
                        </List>

                        <Container className="booking-view__child">
                            <Container.Header>
                                <Container.Text color="#FF6933" fontSize="18px">Summary</Container.Text>
                            </Container.Header>

                            <Container.Content>
                                <List gap="40px">
                                    <Summary
                                        quote={this.state.quote}
                                    />

                                    <ErrorContainer errors={Object.values(this.state?.errors)}>
                                        <div className="agree-box">
                                            <InputsCheckbox
                                                text="I have read and agree to the booking terms and conditions"
                                                checked={this.state.agree}
                                                onChange={(e) => this.setState({ agree: e.value })}
                                            />
                                            <div className="agree-box__content">
                                                <div className="agree-box__details">
                                                    <div className="agree-box-details__detail">
                                                        <p>BACS Due</p>
                                                        <span>£{this.state.quote?.total || 0}</span>
                                                    </div>
                                                </div>

                                                <Blurred toggled={!this.state.agree}>
                                                    <ButtonModify onClick={this.book.bind(this)}>Complete your booking</ButtonModify>
                                                </Blurred>
                                            </div>
                                        </div>
                                    </ErrorContainer>

                                    <Container>
                                        <Container.Header>
                                            <Container.Text fontSize="18px" color="#FF6933">Booking Information</Container.Text>
                                        </Container.Header>

                                        <Container.Content>
                                            <Container.Text fontSize="14px" color="#24191F" html={`${this.state.event?.booking_information}`}></Container.Text>
                                        </Container.Content>
                                    </Container>

                                    <Container>
                                        <Container.Header>
                                            <Container.Text fontSize="18px" color="#FF6933">Contact Us</Container.Text>
                                        </Container.Header>

                                        <Container.Content>
                                            <Container.Text fontSize="14px" color="#24191F" style={{ whiteSpace: 'pre' }}>
                                                +44 (0)1226 720 700

                                                bookings@barnsleydmc.co.uk

                                                DMC
                                                County Way
                                                Barnsley
                                                S70 2JW
                                                UK
                                            </Container.Text>
                                        </Container.Content>
                                    </Container>
                                </List>
                            </Container.Content>
                        </Container>
                    </div>
                }
            />
        </Layout>    
        )
    }
}

const el = document.getElementById('events-edit');

if (el) {
    ReactDOM.render(<EventEdit id={el.getAttribute('data-id')} bookingId={el.getAttribute('data-booking-id')}/> , el);
}
